import React from "react";
import image1 from "../landingImgs/trader1.png";
import image2 from "../landingImgs/trader2.png";
import image3 from "../landingImgs/treder3.png";
import { useMediaQuery } from "react-responsive";

const initialdata = [
  {
    id: 1,
    trader: "Verified Trader",
    details: "Partner with PCB/GST-verified traders for secure transactions.",
    image: image1,
  },
  {
    id: 2,
    trader: "Site Inspections",
    details: "Verify materials and provide feedback.",
    image: image2,
  },
  {
    id: 3,
    trader: "Simplified Transactions",
    details: "Use the Cercle X Wallet for quick payments.",
    image: image3,
  },
];
function TraderFeature() {
  const isDastop = useMediaQuery({ query: "(max-width: 1600px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1500px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 900px)" });

  return (
    <div className="traders">
      {initialdata?.map((items, index) => (
        <div
          data-aos={`flip-left`}
          key={items?.id}
          className={` border-radius-12 flex column  pin-top ${
            index === 0 ? "img1" : index === 1 ? "img2" : "img3"
          }`}
          style={{ border: "1px solid #ACCDFF" }}
        >
          <div
            style={{
              marginTop: "-20px",
              padding: isTablet
                ? "1.5rem 1rem"
                : isLaptop
                ? "2rem"
                : "2.5rem 3rem",
              height: isTablet ? "150px" : isLaptop ? "180px" : "210px",
            }}
          >
            <h4
              className="font-cercular-bold"
              style={{
                fontSize: isTablet ? "18px" : isDastop ? "23px" : "30px",
              }}
            >
              {items?.trader}
            </h4>
            <p
              className={`${isTablet ? "" : "mt-1"} NoOfline`}
              style={{
                fontSize: isTablet ? "13px" : isDastop ? "16px" : "18px",
                letterSpacing: "0.6px",
                WebkitLineClamp: 4,
              }}
            >
              {items?.details}
            </p>
          </div>
          <img
            src={items?.image}
            alt="image1"
            className={`select-wrapper responsive-img image-height`}
          />
        </div>
      ))}
    </div>
  );
}

export default TraderFeature;
